import type { PortalUser, PortalUserMember, SyncUserInfo } from './types';

import { http } from '@/utils/http';

/// 获取用户会员详情
export const memberDetail = (): Promise<PortalUserMember> => {
  return http.request({
    url: '/portal/user/memberDetail',
    method: 'get',
  });
};

/// 获取用户信息详情
export const userDetail = (): Promise<PortalUser> => {
  return http.request({
    url: '/portal/user/userDetail',
    method: 'get',
  });
};

/**
 * 同步更新用户信息
 */
export function syncUserInfo(data: SyncUserInfo): Promise<PortalUser> {
  return http.request({
    url: '/portal/user/syncUserInfo',
    method: 'post',
    data,
  });
}

/// 查询开通了推荐官的用户列表
export const distributorUserList = (): Promise<PortalUser[]> => {
  return http.request({
    url: '/portal/user/distributorUserList',
    method: 'get',
  });
};

/// 查询开通了会员的用户列表
export const memberUserList = (): Promise<PortalUser[]> => {
  return http.request({
    url: '/portal/user/memberUserList',
    method: 'get',
  });
};
